import React from "react";
import "./HomeTestPrep.css";

const SubServiceHero = () => (
  <div>
    <section className="subservice-hero-section">
      <div className="subservice-hero-left">
       
          <h2 className="heading">Test Preparation & Application Support</h2>
        <p className="subservice-hero-desc">Securing admission to a top University requires strong academic and language skills. We offer comprehensive training.
            Our fluent English speaking course and best English speaking course online ensure you are confident in communication, an essential skill for academic success and life abroad.

</p>
      </div>

      <div className="subservice-hero-right mt-5">
        <div className="subservice-hero-card">
          <ul className="subservice-hero-features">
                <li >
                  <span className="subservice-hero-check">✔</span>
                 IELTS/PTE Exam – Boost your score with proven strategies
                </li>
                <li >
                  <span className="subservice-hero-check">✔</span>
                TOEFL Exam – Achieve high proficiency in English
                </li>
                 <li >
                  <span className="subservice-hero-check">✔</span>
               University-specific entrance tests and interviews
                </li>
          </ul>
        </div>
      </div>
    </section>

   
  </div>
);

export default SubServiceHero;
